import React, { useState } from "react";
import { translate } from "@mediaspace/shared/utils";
import { AddNewMenuButton } from "./AddNewMenuButton";
import { Add24Icon } from "@kaltura/ds-react-icons";
import { AddNewMenu as AddNewMenuBase } from "@mediaspace-react-components/shared/add-new";
import { KmsTypeAddNewMenuSection } from "@mediaspace/shared/types/addNew";

export interface AddNewMenuProps {
    sections?: KmsTypeAddNewMenuSection[];
}

/**
 *  `Add New` menu as used in the Kaf pages:
 *   - menu button.
 *   - menu positioning.
 */
export function AddNewMenu(props: AddNewMenuProps) {
    const { sections } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {sections && sections.length > 0 && (
                <>
                    <AddNewMenuButton
                        id={"addNewMenuToggleBtn"}
                        aria-haspopup={true}
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleButtonClick}
                        aria-controls={open ? "addNewMenu" : undefined}
                        aria-label={translate("Create")}
                        startIcon={<Add24Icon />}
                    >
                        {translate("Create")}
                    </AddNewMenuButton>
                    <AddNewMenuBase
                        sections={sections}
                        hideIllustration={true}
                        id={"addNewMenu"}
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        aria-labelledby={"addNewMenuToggleBtn"}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                        }}
                        autoMinHeight={true}
                        narrowMargin={true}
                    />
                </>
            )}
        </>
    );
}

export default AddNewMenu;
